import axios from "axios";
const apiRequest = (method = "get", url, data = {}, headers = null) => {
    let config = {
        method,
        url,
        data,
        validateStatus: (status) => {
            return status >= 200 && status < 400;
        }
    };
    if (headers) {
        config = { ...config, headers };
    }
    switch (method) {
        case "post":
            return axios
                .post(url, data, config)
                .then((response) => {
                return response.data;
            })
                .catch((error) => {
                return Promise.reject(error);
            });
        default:
            return axios
                .get(url, config)
                .then((response) => {
                return response.data;
            })
                .catch((error) => {
                return Promise.reject(error);
            });
    }
};
let uri = `${process.env.VUE_APP_BASE_ENDPOINT}/${process.env.VUE_APP_XMPP_DOMAIN}`;
export default {
    install: (app, options) => {
        app.mixin({
            created() {
                if (Object.prototype.hasOwnProperty.call(options, "basePath")) {
                    uri = options.basePath;
                }
                if (Object.prototype.hasOwnProperty.call(options, "context")) {
                    uri += `/${options.context}`;
                }
            },
            methods: {
                async authenticate(userToken, userThread, host = "", debugMode = false, additionalURLParams = {}) {
                    // const user: XMPPCredentials = {};
                    // const status = apiUser.status;
                    // if (status === "200") {
                    //   user.user = apiUser.body.node;
                    //   user.password = apiUser.body.token;
                    // }
                    // TODO: remove this after implementing token integration
                    // TODO: check parameters with the real authentication ones
                    let user = "driver5";
                    let password = "123456";
                    if (debugMode && additionalURLParams.user && additionalURLParams.pass) {
                        user = additionalURLParams.user;
                        password = additionalURLParams.pass;
                    }
                    return { user, password };
                }
            }
        });
    }
};
